import { useTranslation } from 'react-i18next'
import './PrivacyPolicy.css'

export default function PrivacyPolicy() {
  const { t } = useTranslation()

  return (
    <div className="privacy">
      <div className="privacy__container">
        <h1 className="privacy__title">{t('privacy.title')}</h1>
        <p className="privacy__updated">{t('privacy.updated')}</p>

        <p className="privacy__intro">{t('privacy.intro')}</p>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s1_title')}</h2>
          <p>{t('privacy.s1_intro')}</p>
          <ul className="privacy__list">
            <li><strong>{t('privacy.s1_account')}</strong></li>
            <li><strong>{t('privacy.s1_vehicle')}</strong></li>
            <li><strong>{t('privacy.s1_inspection')}</strong></li>
            <li><strong>{t('privacy.s1_usage')}</strong></li>
            <li><strong>{t('privacy.s1_location')}</strong></li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s2_title')}</h2>
          <ul className="privacy__list">
            <li>{t('privacy.s2_1')}</li>
            <li>{t('privacy.s2_2')}</li>
            <li>{t('privacy.s2_3')}</li>
            <li>{t('privacy.s2_4')}</li>
            <li>{t('privacy.s2_5')}</li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s3_title')}</h2>
          <p>{t('privacy.s3_intro')}</p>
          <ul className="privacy__list">
            <li><strong>{t('privacy.s3_providers')}</strong></li>
            <li><strong>{t('privacy.s3_partners')}</strong></li>
            <li><strong>{t('privacy.s3_legal')}</strong></li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s4_title')}</h2>
          <p>{t('privacy.s4_text')} <a href="mailto:info@vfied.ai" className="privacy__link">info@vfied.ai</a>.</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s5_title')}</h2>
          <p>{t('privacy.s5_text')}</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s6_title')}</h2>
          <p>{t('privacy.s6_intro')}</p>
          <ul className="privacy__list">
            <li>{t('privacy.s6_1')}</li>
            <li>{t('privacy.s6_2')}</li>
            <li>{t('privacy.s6_3')}</li>
            <li>{t('privacy.s6_4')}</li>
            <li>{t('privacy.s6_5')}</li>
          </ul>
          <p>{t('privacy.s6_contact')} <a href="mailto:info@vfied.ai" className="privacy__link">info@vfied.ai</a>.</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s7_title')}</h2>
          <p>{t('privacy.s7_text')}</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s8_title')}</h2>
          <p>{t('privacy.s8_text')}</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s9_title')}</h2>
          <p>{t('privacy.s9_text')}</p>
        </section>

        <section className="privacy__section">
          <h2 className="privacy__section-title">{t('privacy.s10_title')}</h2>
          <p>{t('privacy.s10_intro')}</p>
          <ul className="privacy__list">
            <li>{t('privacy.s10_email')}</li>
            <li><a href="https://verrafied.ai" className="privacy__link">{t('privacy.s10_website')}</a></li>
          </ul>
        </section>
      </div>
    </div>
  )
}
